
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { PlusCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSweepstakesManagement } from '@/hooks/useSweepstakesManagement';
import SweepstakesForm from './SweepstakesForm';
import SweepstakesTable from './SweepstakesTable';
import EntriesTable from './EntriesTable';

const SweepstakesManagement: React.FC = () => {
  const { t } = useTranslationUtils();
  const {
    sweepstakes,
    loading,
    rewards,
    isAddingNew,
    setIsAddingNew,
    editingSweepstakes,
    formValues,
    handleInputChange,
    handleSubmit,
    resetForm,
    handleEdit,
    handleDelete,
    runManualDraw,
    entries,
    loadingEntries,
    fetchEntries,
    selectedSweepstakesId
  } = useSweepstakesManagement();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">{t('admin.sweepstakesManagement', 'Sweepstakes Management')}</h2>
        {!isAddingNew && (
          <Button 
            onClick={() => setIsAddingNew(true)}
            className="flex items-center gap-2"
          >
            <PlusCircle className="h-4 w-4" />
            {t('admin.createSweepstakes', 'Create Sweepstakes')}
          </Button>
        )}
      </div>

      {isAddingNew && (
        <SweepstakesForm
          editingSweepstakes={editingSweepstakes}
          formValues={formValues}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          resetForm={resetForm}
          rewards={rewards}
        />
      )}

      <SweepstakesTable
        sweepstakes={sweepstakes}
        loading={loading}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        runManualDraw={runManualDraw}
        fetchEntries={fetchEntries}
      />

      {selectedSweepstakesId && (
        <EntriesTable
          entries={entries}
          loading={loadingEntries}
          sweepstakesId={selectedSweepstakesId}
        />
      )}
    </div>
  );
};

export default SweepstakesManagement;
